var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_vm._v(" Viewership ")]),_c('v-content',[_c('Viewership')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }